<div fxLayout="column" fxLayoutAlign="center center" class="w250px">
  <h6 class="h6Title mgb40">Iniciar sesión</h6>
  <br>

  <!-- <div class="inputContainer-last">
    <input type="text" class="form-control-full-width" placeholder="Username" #userName required>
  </div>

  <div class="inputContainer-last">
    <input type="password" class="form-control-full-width" placeholder="Password" #userPassword required>
  </div>

  <div class="inputContainer-last">
    <input type="button" class="blue-button-full-width" value="Iniciar sesión"
      (click)="authService.SignIn(userName.value, userPassword.value)" (click)="openSignUp">
  </div> -->


  <div class="fw mgb10">
    <button type="button" class="fw redButton ft500 gray-2 fw shadow20" (click)="authService.GoogleAuth(); this.dialogRefActual.close()">
      <i class="fab fa-google"></i>
      &nbsp;
      Iniciar sesión con Google
    </button>
  </div>

  <!-- <div class="fw mgb20">
      <button type="button" class="fw blueButton" (click)="authService.loginWithFB()">
        <i class="fab fa-facebook"></i>
        &nbsp;
        Iniciar sesión con Facebook
      </button>
    </div>
  </div> -->


  <!-- <a class="blackLink" (click)="openForgotPassword()" [mat-dialog-close]="true">¿Olvidaste tu contraseña?</a>
        &nbsp; -->

  <p class="centertext mgb0"> ¿No te has registrado? </p>
  <a class="blueLink ft500  centertext" (click)="openSignUp()"> Regístrate </a>
  <!-- <a class="blueLink" [mat-dialog-close]="true" class="blueLink" > Regístrate</a> -->

  <br>

</div>